module.exports = __webpack_public_path__ + "static/media/headerBottomBorderIcon.307c8c65.png";